import { Component, Input } from "@angular/core";

@Component({
  selector: "app-loading-spinner",
  standalone: false,
  template: `
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p *ngIf="message">{{ message }}</p>
    </div>
  `,
  styles: [
    `
      .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 24px;
      }
      p {
        margin-top: 16px;
        color: rgba(0, 0, 0, 0.54);
      }
    `,
  ],
})
export class LoadingSpinnerComponent {
  @Input() message = "Loading...";
}
